import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';

import { ShDialogBoxComponent, LocalData, DialogDataResponse } from './dialog-box.component';

@Injectable()
export class ShDialogBoxService {
	public dialogRefId: string | undefined;

	public readonly defaultDialogConfig: MatDialogConfig = { width: '400px' };

	constructor(private dialog: MatDialog) {}

	/**
	 * popup dialog
	 * @param {string} title
	 * @param {LocalData} localData
	 * @param {MatDialogConfig} [config={}]
	 * @returns {Observable<DialogDataResponse>}
	 */
	public openDialog(
		title: string,
		localData?: LocalData | undefined,
		config: MatDialogConfig = this.defaultDialogConfig
	): Observable<DialogDataResponse> {
		let dialogRef: MatDialogRef<ShDialogBoxComponent> | undefined;

		if (this.dialogRefId && this.dialog.openDialogs.length) {
			dialogRef = <MatDialogRef<ShDialogBoxComponent>>this.dialog.getDialogById(this.dialogRefId);
		}

		if (dialogRef && dialogRef.componentInstance) {
			return dialogRef.afterClosed();
		}
		dialogRef = this.dialog.open(ShDialogBoxComponent, config);
		dialogRef.componentInstance.localData = localData;
		dialogRef.componentInstance.title = title;
		this.dialogRefId = dialogRef.id;
		return dialogRef.afterClosed().pipe(map((row) => row));
	}
}
